import * as React from 'react';
import type { SVGProps } from 'react';
const SvgMinusCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    aria-label="MinusCircle"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M5.25 10A.75.75 0 0 1 6 9.25h7.75a.75.75 0 0 1 0 1.5H6a.75.75 0 0 1-.75-.75"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M10 16.5a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13m0 1.5a8 8 0 1 0 0-16 8 8 0 0 0 0 16"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgMinusCircle;
